import { Action } from "../../../../common/enum";
import { MachineInput } from "../../components/MachineInput";

export default function MachineAddInput() {
  return (
    <MachineInput
      reviewRoute={"/machine/add/review"}
      title={"Machine Add Input"}
      action={Action.CREATE}
    />
  );
}
